import { BannerPrimary } from '@sbercloud/uikit-product-site-banner';
import { jsx as _jsx } from "react/jsx-runtime";
export function FreeCoursesAndCertification(_ref) {
  var href = _ref.href,
    onClick = _ref.onClick,
    layoutType = _ref.layoutType;
  return /*#__PURE__*/_jsx(BannerPrimary, {
    title: "\u0411\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u044B\u0435 \u043A\u0443\u0440\u0441\u044B \u0438 \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0438",
    description: "\u041F\u043E\u0437\u043D\u0430\u043A\u043E\u043C\u044C\u0442\u0435\u0441\u044C \u0441 \u0441\u0435\u0440\u0432\u0438\u0441\u0430\u043C\u0438 \u043E\u0431\u043B\u0430\u0447\u043D\u044B\u0445 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C Cloud.ru \u043D\u0430 \u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u044B\u0445 \u043A\u0443\u0440\u0441\u0430\u0445. \u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043A\u0443\u0440\u0441, \u043F\u0440\u043E\u0439\u0434\u0438\u0442\u0435 \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044E \u0438 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435 \u0441\u0432\u043E\u0438 \u0437\u043D\u0430\u043D\u0438\u044F \u043E\u0431\u043B\u0430\u0447\u043D\u044B\u0445 \u0442\u0435\u0445\u043D\u043E\u043B\u043E\u0433\u0438\u0439",
    img: "https://cdn.cloud.ru/backend/images/education/banners/free_courses_and_certification.webp",
    imgType: "rectangle",
    appearance: "decor",
    color: "blue",
    layoutType: layoutType,
    buttons: [{
      label: 'Подробнее',
      href: href,
      onClick: onClick
    }]
  });
}